import axios from 'axios'

export default {
    namespaced: true,
    state: {
        addWorks: [],
        hotelAddWorks: [],
    },
    mutations: {
        CLEAR_DATA(state) {
            state.addWorks = []
            state.hotelAddWorks = []
        },
        FETCH_AW(state, payload) {
            state.addWorks = payload.filter(e => e.hotel_id === null)
            state.hotelAddWorks = payload.filter(e => e.hotel_id !== null)
        },
        ADD_AW(state, payload) {
            let wtype = payload.hotel_id === null || !payload.hotel_id ?
                state.addWorks :
                state.hotelAddWorks

            const index = wtype.findIndex(
                item => item.id === payload.id
            )
            if (index !== -1) {
                Object.assign(wtype[index], payload)
            } else {
                wtype.push(payload)
            }
        },
        EDIT_AW(state, payload) {
            let wtype = payload.hotel_id === null || !payload.hotel_id ?
                state.addWorks :
                state.hotelAddWorks

            const index = wtype.findIndex(
                item => item.id === payload.id
            )
            if (index !== -1) {
                Object.assign(wtype[index], payload)
            }
        },
        DEL_AW(state, payload) {
            let wtype = payload.hotel_id === null ?
                state.addWorks :
                state.hotelAddWorks

            const index = wtype.findIndex(
                item => item.id === payload.id
            )
            if (index !== -1) {
                wtype.splice(index, 1)
            }
        },
    },
    actions: {
        fetch({commit, dispatch}, payload) {
            let queryStr = payload ?
                '/api/root/add-works?hotel_id=' + payload.hotel_id :
                '/api/root/add-works'

            return new Promise((resolve, reject) => {
                axios.get(
                    queryStr
                ).then(({data}) => {
                    commit('FETCH_AW', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                    reject(error)
                })
            })
        },
        add({dispatch, commit}, data) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/root/add-works',
                    data
                ).then(({data}) => {
                    commit('ADD_AW', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        edit({dispatch, commit}, payload) {
            return new Promise((resolve) => {
                axios.put(
                    '/api/root/add-works/' + payload.id,
                    payload
                ).then(({data}) => {
                    commit('EDIT_AW', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        delete({dispatch, commit}, payload) {
            return new Promise((resolve) => {
                axios.delete(
                    '/api/root/add-works/' + payload.id,
                ).then(() => {
                    commit('DEL_AW', payload)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
    },
}
